module.exports = __webpack_public_path__ + "static/media/footer.d0be8fab.png";